module.exports = __webpack_public_path__ + "img/GBR.4e7b25ff.svg";